import { applyMiddleware, createStore, compose } from 'redux';
import { promiseMiddleware, localStorageMiddleware } from './middlewareConfig';
import reducer from './reducerConfig';

import { routerMiddleware } from 'react-router-redux'

import { createBrowserHistory as createHistory } from 'history'
export const history = createHistory()

// Build the middleware for intercepting and dispatching navigation actions
const myRouterMiddleware = routerMiddleware(history);

const middlewares = [myRouterMiddleware, promiseMiddleware, localStorageMiddleware];

const middlewareEnhancer = applyMiddleware(...middlewares);

let enhancer;
if (process.env.NODE_ENV === 'production') {
  enhancer = middlewareEnhancer;
} else {
  // Use Redux DevTools extension compose if available, otherwise fall back to Redux compose
  const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
  enhancer = composeEnhancers(middlewareEnhancer);
}

export const store = createStore(reducer, enhancer);
